module.exports = __webpack_public_path__ + "c6f8ee0c3b92417139cc3b639b37bb71.png";